<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('recharge.nickName')" prop="userId">
                <a-input v-model="queryParam.nickName" :placeholder="$t('recharge.inputNickName')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('recharge.mobile')" prop="mobile">
                <a-input v-model="queryParam.mobile" :placeholder="$t('recharge.inputMobile')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('recharge.email')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('recharge.inputEmail')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('recharge.orderNo')" prop="orderNo">
                <a-input v-model="queryParam.orderNo" :placeholder="$t('recharge.inputOrderNo')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!--              <a-col :md="5" :sm="24">-->
              <!--                <a-form-item label="支付单号" prop="payNo">-->
              <!--                  <a-input v-model="queryParam.payNo" placeholder="请输入支付单号" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="5" :sm="24">-->
              <!--                <a-form-item label="三方订单号" prop="outTrandNo">-->
              <!--                  <a-input v-model="queryParam.outTrandNo" placeholder="请输入三方订单号" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="5" :sm="24">-->
              <!--                <a-form-item label="充值金币数" prop="rechargeDiamond">-->
              <!--                  <a-input v-model="queryParam.rechargeDiamond" placeholder="请输入充值金币数" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="5" :sm="24">-->
              <!--                <a-form-item label="支付金额" prop="payMoney">-->
              <!--                  <a-input v-model="queryParam.payMoney" placeholder="请输入支付金额" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="5" :sm="24">-->
              <!--                <a-form-item label="价格菜单id" prop="menuId">-->
              <!--                  <a-input v-model="queryParam.menuId" placeholder="请输入价格菜单id" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('recharge.payTime')" prop="payTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.payTime" @change="changePayTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['recharge:order:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['recharge:order:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <!-- v-hasPermi="['recharge:order:remove']" -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <!-- v-hasPermi="['recharge:order:export']" -->
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />{{ $t('common.export') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1400 }"
        :rowKey="(record, index) => index + 1"
      >
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!-- v-hasPermi="['recharge:order:edit']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['recharge:order:edit']" -->
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['recharge:order:remove']" />-->
          <!--          <a @click="handleDelete(record)" v-hasPermi="['recharge:order:remove']">-->
          <!--            <a-icon type="delete" />删除-->
          <!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOrder,listOrder, delOrder } from '@/api/recharge/order'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Order',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        nickName: null,
        mobile: null,
        email: null,
        orderNo: null,
        payNo: null,
        outTrandNo: null,
        rechargeDiamond: null,
        payMoney: null,
        menuId: null,
        payTime: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('recharge.nickName'),
          dataIndex: 'nickName',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('recharge.mobile'),
          dataIndex: 'mobile',
          width: 140,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('recharge.email'),
          dataIndex: 'email',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('recharge.orderNo'),
          dataIndex: 'orderNo',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('recharge.rechargeDiamond'),
          dataIndex: 'rechargeDiamond',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('recharge.giveDiamond'),
          dataIndex: 'giveDiamond',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('recharge.payMoney'),
          dataIndex: 'payMoney',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('recharge.payTime'),
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('recharge.status'),
          dataIndex: 'status',
          width: 100,
          customRender: (t) => {
            if (t == 0) {
              return this.$t('recharge.pendingPay');
            } else if (t == 1) {
              return this.$t('recharge.paySuccess');
            } else if (t == 2) {
              return this.$t('recharge.payFailed');
            }
          },
          align: 'center'
        },
        {
          title: this.$t('recharge.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 180,
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询金币充值订单列表 */
    getList () {
      this.loading = true
      pageOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        nickName: undefined,
        mobile: undefined,
        email: undefined,
        orderNo: undefined,
        payNo: undefined,
        outTrandNo: undefined,
        rechargeDiamond: undefined,
        payMoney: undefined,
        menuId: undefined,
        payTime: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('recharge.confirmDelete'),
        content: this.$t('recharge.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('recharge.confirmExport'),
        content: this.$t('recharge.confirmExportContent'),
        onOk () {
          that.download('recharge/recharge-orders/exportOrder', {
            ...that.queryParam
          }, `${that.$t('recharge.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
